import React from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'next-i18next';
import { Button, Typography } from '@/components/atoms';
import { PassengerCardProps } from './PassengerCard.types';
import { Container, Row, Column } from './PassengerCard.styles';
import { useCountries } from '@/services/countries';
import * as FeatherIcon from 'react-feather';

const PassengerCard: React.FC<PassengerCardProps> = ({ status, passenger, initialData, idNumber, onEdit, children }) => {
    const { t } = useTranslation(); // Translations
    const theme = useTheme(); // Get current
    const { countries } = useCountries();

    const passengerTypes: {
        [key: string]: string;
    } = {
        Adult: t('flights:passenger.type.adult'),
        Child: t('flights:passenger.type.child'),
    };

    return (
        <Container>
            <Row>
                <Column>
                    <Typography variant="h6" align="left" color={status === 'disabled' ? theme.colors.neutral.neutral70 : theme.colors.neutral.neutral10}>
                        {t('flights:passenger.label')} {passenger.number} - {passengerTypes[passenger.type]}
                    </Typography>
                    {(!!initialData?.namePrefix || !!initialData?.givenName || !!initialData?.middleName || !!initialData?.surname) && (
                        <Typography variant="body1" align="left" color={status === 'disabled' ? theme.colors.neutral.neutral70 : theme.colors.neutral.neutral10} mt={5}>
                            {initialData?.namePrefix}. {initialData?.givenName} {initialData?.middleName} {initialData?.surname}
                        </Typography>
                    )}
                    {status === 'saved' && (
                        <>
                            <Typography variant="body2" align="left">
                                {idNumber}
                            </Typography>
                            <Row>
                                <Column>
                                    <Typography variant="body2" align="left" mt={30}>
                                        <b style={{ marginRight: 10 }}>{initialData?.idDocumentType}:</b> {initialData?.idNumber}
                                    </Typography>
                                </Column>
                                <Column>
                                    <Typography variant="body2" align="left" mt={30}>
                                        <b style={{ marginRight: 10 }}>{t('flights:passenger.gender.label')}:</b> {initialData?.gender}
                                    </Typography>
                                </Column>
                            </Row>
                            <Row>
                                <Column>
                                    <Typography variant="body2" align="left" mt={10}>
                                        <b style={{ marginRight: 10 }}>{t('flights:passenger.phone.label')}:</b> {initialData?.phoneNumber}
                                    </Typography>
                                </Column>
                                <Column>
                                    <Typography variant="body2" align="left" mt={10}>
                                        <b style={{ marginRight: 10 }}>{t('flights:passenger.email.label')}:</b> {initialData?.email}
                                    </Typography>
                                </Column>
                            </Row>
                            <Row>
                                <Column>
                                    <Typography variant="body2" align="left" mt={10}>
                                        <b style={{ marginRight: 10 }}>{t('flights:passenger.nationality.label')}:</b>{' '}
                                        {countries.find((item) => item.id === initialData?.birthCountry)?.name}
                                    </Typography>
                                </Column>
                                <Column>
                                    <Typography variant="body2" align="left" mt={10}>
                                        <b style={{ marginRight: 10 }}>{t('flights:passenger.passport-issue-country.label')}:</b>{' '}
                                        {countries.find((item) => item.id === initialData?.documentIssueCountry)?.name}
                                    </Typography>
                                </Column>
                            </Row>
                            <Row>
                                <Column>
                                    <Typography variant="body2" align="left" mt={10}>
                                        <b style={{ marginRight: 10 }}>{t('flights:passenger.passport-created-date.label')}:</b> {initialData?.passportCreatedDate}
                                    </Typography>
                                </Column>
                                <Column>
                                    <Typography variant="body2" align="left" mt={10}>
                                        <b style={{ marginRight: 10 }}>{t('flights:passenger.passport-expire-date.label')}:</b> {initialData?.documentExpireDate}
                                    </Typography>
                                </Column>
                            </Row>
                            <Row>
                                <Column>
                                    <Typography variant="body2" align="left" mt={10}>
                                        <b style={{ marginRight: 10 }}>{t('flights:passenger.birth-date.label')}:</b> {initialData?.birthdate}
                                    </Typography>
                                </Column>
                                <Column>
                                    <Typography variant="body2" align="left" mt={10}>
                                        <b style={{ marginRight: 10 }}>{t('flights:passenger.luggage.label')}:</b> 1bag / 23kg
                                    </Typography>
                                </Column>
                            </Row>
                        </>
                    )}
                </Column>
                {status === 'saved' && <Button content={<FeatherIcon.Edit3 color={theme.colors.primary.primary40} size={20} />} type="submit" variant="text" onClick={onEdit} />}
            </Row>
            {status === 'active' && children}
        </Container>
    );
};
export default PassengerCard;
